import { type QueryOptions } from '@tanstack/query-core'

import { type DcEntity } from '@/libs/api'
import { type DcsListRequestQuery } from '@/libs/api/types'

import { fetchDcs } from '../api'
import { dcsQueryKeys } from '../query-keys'

/**
 * Select用の拠点(物流センター)一覧のQueryOptionsを返す
 */
export const getDcsSelectQueryOptions = (
  tenantKey: string,
  query?: DcsListRequestQuery
): Required<Pick<QueryOptions<DcEntity[]>, 'queryKey' | 'queryFn'>> => {
  return {
    queryKey: dcsQueryKeys.select(tenantKey, query),
    queryFn: async ({ signal }) => {
      const { data } = await fetchDcs(
        {
          tenantKey,
          query
        },
        signal
      )
      return data
    }
  }
}
